import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import { ContextMenu, MenuItem, ContextMenuTrigger, SubMenu } from "react-contextmenu";
import _ from 'lodash'

import {Config, Regex} from '../../util';
// import LogoUrl from '../../util/LogoUrl';


class ListContainer extends PureComponent {
  constructor(props){
    super(props);

    this.handleContextMenuClick = this.handleContextMenuClick.bind(this);
    this.handleDetailMenuClick = this.handleDetailMenuClick.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleContextMenuClick(event, data) {
    const options = Object.assign({}, this.props.item);
    delete options.onClick;
    delete options.onContextMenuClick;
    options.data = data.item;

    if(typeof this.props.onContextMenuClick === 'function'){
      this.props.onContextMenuClick(options);
    }
  }

  handleOnClick(event, data) {

    const options = Object.assign({}, this.props.item);
    options.start = moment(options.start, 'YYYYMMDDHHmmss');
    options.stop = moment(options.stop, 'YYYYMMDDHHmmss');
    options.filename = options.url.split('/').filter(urlfrag => urlfrag.includes('.mp4'))[0];
    delete options.onClick;
    delete options.onContextMenuClick;
    
    if(typeof this.props.onClick === 'function'){
      this.props.onClick(options);
    }
  }

  handleDetailMenuClick(event){
    const options = Object.assign({}, this.props);
    if(typeof this.props.onDetailClick === 'function'){
      this.props.onDetailClick(options.item);
    }
  }



  render (){
    const {item, activePage, index, searchCondition, onDetailClick} = this.props;
    const idx = activePage === 1 ? parseInt(item.num, 10) : (activePage - 1) * searchCondition.pageSize + parseInt(item.num, 10);
    // const idx = activePage === 1 ? parseInt(index, 10) + 1 : (activePage - 1) * searchCondition.pageSize + parseInt(index, 10) + 1;
    const id = item.chname + '_' + item.start;
    const formattedStime = moment(item.start, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss').split(' ');
    const formattedETime = moment(item.stop, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss').split(' ');
    const imgWhite =_.keyBy(Config.logoUrl, 'epgId')[item.epgid] &&  _.keyBy(Config.logoUrl, 'epgId')[item.epgid].imgWhite;
    const isMenuItemName = !Config.isPreviewMenuName && Config.logoUrl && Config.logoUrl.length > 0; 
    const newIdx = moment().isSame(formattedStime[0], 'day'); // 오늘날짜 비교
    return [
      <ContextMenuTrigger id={id} holdToDisplay={-1} key={id}>
        <li className='list item' onDoubleClick={this.handleOnClick}>
         <div className='idx'>{newIdx ? <img src="/static/img/new_icon.png" alt={idx} /> : idx}</div>
          <div className='logo'>
            <img src={imgWhite} alt='' />
          </div>
          {/* <div className='thumbnail'>
            <img src={item.img} alt='' />
          </div> */}
          <div className='description'>
            <div className='full-date'>{formattedStime[0]}
              <span> {formattedStime[1]} </span>
               - {formattedETime[0]}
              <span> {formattedETime[1]} </span> 
              <span> {item.category} </span> 
              <span> {item.price && item.price && Regex.getPriceComma(item.price)}</span>
             </div>
            <div className='title'>
              {item.title}
              <span className='desc'>{item.director}</span>
            </div>
          </div>
        </li>
      </ContextMenuTrigger>,
      <ContextMenu id={id} className='react-contextmenu-custom' key={`${id}_contextmenu`} >
        <MenuItem onClick={this.handleDetailMenuClick} data={{ item: 'Popup' }}>Detail View</MenuItem>
        <MenuItem divider />
        <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video1' }}>{isMenuItemName ? Config.logoUrl[0].id : "Preview1"}</MenuItem>
        <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video2' }}>{isMenuItemName ? Config.logoUrl[1].id : "Preview2"}</MenuItem>
        <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video3' }}>{isMenuItemName ? Config.logoUrl[2].id : "Preview3"}</MenuItem>
        <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video4' }}>{isMenuItemName ? Config.logoUrl[3].id : "Preview4"}</MenuItem>
      </ContextMenu>
    ];
  }
}

const mapStateToProps = (state) => {
  return {
    searchCondition: state.searchCondition
  }
};

ListContainer = connect(mapStateToProps)(ListContainer);

export default ListContainer;


// WEBPACK FOOTER //
// ./src/components/list/index.js